// OwlCarousel
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import { useNavigate } from "react-router-dom";

const HomeSlider = ({ adBannerData = [] }) => {

  const navigate = useNavigate();

  const navigateTo = (link) => {
    if(link) {
      navigate(link, true);
    }
  }

  const ownCarouselOptions = {
    loop: true, // Small margin for better spacing
    autoplay: true,
    autoplayTimeout: 1500,
    smartSpeed: 450, // Controls smooth transition
    nav: false, // Since no arrows are used
    dots: false, // Hides dots unless needed
    items: 1, // Correct for text-only sliding
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  };
  return (
    <section className="home-slider-section">
      <div className="py-4 py-md-1">
        <div className="own-container">
          <div className="py-1">
            <h2 className="py-2">Latest Insights</h2>
            <OwlCarousel className="owl-theme" {...ownCarouselOptions}>
              {adBannerData.map((item) => (
                <div key={item.id} onClick={() => navigateTo(item.link ? item.link : "#")} className="py-2 px-2">
                  <img src={item.image} alt={item.title} className="rounded-2"/>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeSlider;